var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "act-repurchase-root",
      class: { "ar-style": _vm.$i18n.locale === "ar" },
    },
    [
      _c(
        "div",
        {
          staticClass: "custom-nav-block",
          class: _vm.packageName,
          style: `padding-top:${_vm.barHeight}px`,
        },
        [
          _c("van-nav-bar", {
            staticClass: "van-bar",
            attrs: { title: "", "left-arrow": "" },
            on: {
              "click-left": _vm.closeWeb,
              "click-right": function ($event) {
                return _vm.toggleShowRules(true)
              },
            },
            scopedSlots: _vm._u([
              {
                key: "left",
                fn: function () {
                  return [
                    _c("img", {
                      staticClass: "left-nav",
                      attrs: {
                        src: require("@/assets/packageAssets/common/arrow01.png"),
                        alt: "",
                      },
                    }),
                  ]
                },
                proxy: true,
              },
              {
                key: "right",
                fn: function () {
                  return [
                    _c("div", { staticClass: "right-tips" }, [
                      _vm._v(_vm._s(_vm.$t("lang.call.tit1"))),
                    ]),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "repurchase-content",
          style: `margin-top:-${_vm.barHeight + 46}px`,
        },
        [
          _vm.packageName === "echo"
            ? _c("img", {
                staticClass: "banner-img",
                attrs: { src: require("./images/bg-2.png") },
              })
            : _c("img", {
                staticClass: "banner-img",
                attrs: { src: require("./images/bg-1.png") },
              }),
          _c(
            "div",
            {
              staticClass: "main-table",
              style: `margin-top:-${_vm.barHeight + 262}px`,
            },
            [
              _c("div", { staticClass: "main-tit1" }, [
                _vm._v(_vm._s(_vm.$t("lang.commonM.k143"))),
              ]),
              _c(
                "div",
                { staticClass: "main-tit2" },
                [
                  _c("MyPLabel", {
                    attrs: {
                      str: _vm.$t("lang.commonM.k144"),
                      customClass: { coin: "repurchase-tit-coin" },
                    },
                  }),
                ],
                1
              ),
              _c("div", { staticClass: "main-timer-block" }, [
                _vm.displayTime
                  ? _c("div", { staticClass: "main-timer" }, [
                      _c("img", {
                        attrs: { src: require("./images/clock.png") },
                      }),
                      _vm._v(" " + _vm._s(_vm.$t("lang.commonM.k145")) + " "),
                      _c("span", [_vm._v(_vm._s(_vm.displayTime.days))]),
                      _vm._v(" : "),
                      _c("span", [_vm._v(_vm._s(_vm.displayTime.hours))]),
                      _vm._v(" : "),
                      _c("span", [_vm._v(_vm._s(_vm.displayTime.minutes))]),
                      _vm._v(" : "),
                      _c("span", [_vm._v(_vm._s(_vm.displayTime.seconds))]),
                    ])
                  : _vm._e(),
              ]),
              _vm.baseInfo && _vm.baseInfo.taskProc && _vm.baseInfo.taskProc[0]
                ? _c(
                    "div",
                    { staticClass: "reward-block" },
                    [
                      _c("div", { staticClass: "reward-head" }, [
                        _c("img", {
                          attrs: { src: require("./images/star.png") },
                        }),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("lang.intimate.reward")) + " 1"),
                        ]),
                        _c("img", {
                          attrs: { src: require("./images/star.png") },
                        }),
                      ]),
                      _c("div", { staticClass: "percent-tips" }, [
                        _c("i", [
                          _vm._v(_vm._s(_vm.baseInfo.taskProc[0].proc)),
                        ]),
                        _vm._v(
                          " /" + _vm._s(_vm.baseInfo.taskProc[0].target) + " "
                        ),
                        _c("img", { attrs: { src: _vm.getMatchImg("coin") } }),
                      ]),
                      _c("div", { staticClass: "percent-bar" }, [
                        _c("div", {
                          staticClass: "percent-track",
                          style: {
                            width: `${_vm.baseInfo.taskProc[0].percent}%`,
                          },
                        }),
                      ]),
                      _c(
                        "div",
                        { staticClass: "gifts", staticStyle: { gap: "10px" } },
                        [
                          _c("div", [
                            _c("img", {
                              attrs: { src: _vm.getMatchImg("coins"), alt: "" },
                            }),
                            _vm.baseInfo.taskProc[0].rewards
                              ? _c("div", { staticClass: "rewards-count" }, [
                                  _vm._v(
                                    "x" +
                                      _vm._s(
                                        _vm.baseInfo.taskProc[0].rewards[0]
                                          .number || 0
                                      )
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                          _c("div", [
                            _c("img", {
                              attrs: {
                                src: _vm.getMatchImg("coupon"),
                                alt: "",
                              },
                            }),
                            _vm.baseInfo.taskProc[0].rewards
                              ? _c("div", { staticClass: "rewards-count" }, [
                                  _vm._v(
                                    "x" +
                                      _vm._s(
                                        _vm.baseInfo.taskProc[0].rewards[1]
                                          .number || 0
                                      )
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                          _c("div", [
                            _c("img", {
                              attrs: {
                                src: _vm.getMatchImg("video-pass"),
                                alt: "",
                              },
                            }),
                            _vm.baseInfo.taskProc[0].rewards
                              ? _c("div", { staticClass: "rewards-count" }, [
                                  _vm._v(
                                    "x" +
                                      _vm._s(
                                        _vm.baseInfo.taskProc[0].rewards[2]
                                          .number || 0
                                      )
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                          _c("div", [
                            _c("img", {
                              attrs: {
                                src: _vm.getMatchImg("super-chat-pass"),
                                alt: "",
                              },
                            }),
                            _vm.baseInfo.taskProc[0].rewards
                              ? _c("div", { staticClass: "rewards-count" }, [
                                  _vm._v(
                                    "x" +
                                      _vm._s(
                                        _vm.baseInfo.taskProc[0].rewards[3]
                                          .number || 0
                                      )
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                        ]
                      ),
                      _vm.baseInfo.taskProc[0].ifDone === false
                        ? [
                            _c("div", { staticClass: "claim-btn off-btn" }, [
                              _vm._v(_vm._s(_vm.$t("lang.commonM.k073"))),
                            ]),
                          ]
                        : _vm._e(),
                      _vm.baseInfo.taskProc[0].ifDone === true
                        ? [
                            _vm.baseInfo.taskProc[0].ifClaimed === false
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "claim-btn",
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleClaim(
                                          _vm.baseInfo.taskProc[0],
                                          0
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("lang.commonM.k073")))]
                                )
                              : _c(
                                  "div",
                                  { staticClass: "claim-btn off-btn" },
                                  [_vm._v(_vm._s(_vm.$t("lang.commonM.k074")))]
                                ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  )
                : _vm._e(),
              _vm.baseInfo && _vm.baseInfo.taskProc && _vm.baseInfo.taskProc[1]
                ? _c(
                    "div",
                    { staticClass: "reward-block" },
                    [
                      _c("div", { staticClass: "reward-head" }, [
                        _c("img", {
                          attrs: { src: require("./images/star.png") },
                        }),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("lang.intimate.reward")) + " 2"),
                        ]),
                        _c("img", {
                          attrs: { src: require("./images/star.png") },
                        }),
                      ]),
                      _c("div", { staticClass: "percent-tips" }, [
                        _c("i", [
                          _vm._v(_vm._s(_vm.baseInfo.taskProc[1].proc)),
                        ]),
                        _vm._v(
                          "/" + _vm._s(_vm.baseInfo.taskProc[1].target) + " "
                        ),
                        _c("img", { attrs: { src: _vm.getMatchImg("coin") } }),
                      ]),
                      _c("div", { staticClass: "percent-bar" }, [
                        _c("div", {
                          staticClass: "percent-track",
                          style: {
                            width: `${_vm.baseInfo.taskProc[1].percent}%`,
                          },
                        }),
                      ]),
                      _c(
                        "div",
                        { staticClass: "gifts", staticStyle: { gap: "10px" } },
                        [
                          _c("div", [
                            _c("img", {
                              attrs: { src: _vm.getMatchImg("coins"), alt: "" },
                            }),
                            _vm.baseInfo.taskProc[1].rewards
                              ? _c("div", { staticClass: "rewards-count" }, [
                                  _vm._v(
                                    "x" +
                                      _vm._s(
                                        _vm.baseInfo.taskProc[1].rewards[0]
                                          .number || 0
                                      )
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                          _c("div", [
                            _c("img", {
                              attrs: {
                                src: _vm.getMatchImg("video-pass"),
                                alt: "",
                              },
                            }),
                            _vm.baseInfo.taskProc[1].rewards
                              ? _c("div", { staticClass: "rewards-count" }, [
                                  _vm._v(
                                    "x" +
                                      _vm._s(
                                        _vm.baseInfo.taskProc[1].rewards[1]
                                          .number || 0
                                      )
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                          _c("div", [
                            _c("img", {
                              attrs: {
                                src: _vm.getMatchImg("super-chat-pass"),
                                alt: "",
                              },
                            }),
                            _vm.baseInfo.taskProc[1].rewards
                              ? _c("div", { staticClass: "rewards-count" }, [
                                  _vm._v(
                                    "x" +
                                      _vm._s(
                                        _vm.baseInfo.taskProc[1].rewards[2]
                                          .number || 0
                                      )
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                        ]
                      ),
                      _vm.baseInfo.taskProc[1].ifDone === false
                        ? [
                            _c("div", { staticClass: "claim-btn off-btn" }, [
                              _vm._v(_vm._s(_vm.$t("lang.commonM.k073"))),
                            ]),
                          ]
                        : _vm._e(),
                      _vm.baseInfo.taskProc[1].ifDone === true
                        ? [
                            _vm.baseInfo.taskProc[1].ifClaimed === false
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "claim-btn",
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleClaim(
                                          _vm.baseInfo.taskProc[1],
                                          1
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("lang.commonM.k073")))]
                                )
                              : _c(
                                  "div",
                                  { staticClass: "claim-btn off-btn" },
                                  [_vm._v(_vm._s(_vm.$t("lang.commonM.k074")))]
                                ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  )
                : _vm._e(),
              _vm.baseInfo && _vm.baseInfo.taskProc && _vm.baseInfo.taskProc[2]
                ? _c(
                    "div",
                    { staticClass: "reward-block" },
                    [
                      _c("div", { staticClass: "reward-head" }, [
                        _c("img", {
                          attrs: { src: require("./images/star.png") },
                        }),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("lang.intimate.reward")) + " 3"),
                        ]),
                        _c("img", {
                          attrs: { src: require("./images/star.png") },
                        }),
                      ]),
                      _c("div", { staticClass: "percent-tips" }, [
                        _c("i", [
                          _vm._v(_vm._s(_vm.baseInfo.taskProc[2].proc)),
                        ]),
                        _vm._v(
                          " /" + _vm._s(_vm.baseInfo.taskProc[2].target) + " "
                        ),
                        _c("img", { attrs: { src: _vm.getMatchImg("coin") } }),
                      ]),
                      _c("div", { staticClass: "percent-bar" }, [
                        _c("div", {
                          staticClass: "percent-track",
                          style: {
                            width: `${_vm.baseInfo.taskProc[2].percent}%`,
                          },
                        }),
                      ]),
                      _c(
                        "div",
                        { staticClass: "gifts", staticStyle: { gap: "10px" } },
                        [
                          _c("div", [
                            _c("img", {
                              attrs: { src: _vm.getMatchImg("coins"), alt: "" },
                            }),
                            _vm.baseInfo.taskProc[2].rewards
                              ? _c("div", { staticClass: "rewards-count" }, [
                                  _vm._v(
                                    "x" +
                                      _vm._s(
                                        _vm.baseInfo.taskProc[2].rewards[0]
                                          .number || 0
                                      )
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                          _c("div", [
                            _c("img", {
                              attrs: {
                                src: _vm.getMatchImg("video-pass"),
                                alt: "",
                              },
                            }),
                            _vm.baseInfo.taskProc[2].rewards
                              ? _c("div", { staticClass: "rewards-count" }, [
                                  _vm._v(
                                    "x" +
                                      _vm._s(
                                        _vm.baseInfo.taskProc[2].rewards[1]
                                          .number || 0
                                      )
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                          _c("div", [
                            _c("img", {
                              attrs: {
                                src: _vm.getMatchImg("super-chat-pass"),
                                alt: "",
                              },
                            }),
                            _vm.baseInfo.taskProc[2].rewards
                              ? _c("div", { staticClass: "rewards-count" }, [
                                  _vm._v(
                                    "x" +
                                      _vm._s(
                                        _vm.baseInfo.taskProc[2].rewards[2]
                                          .number || 0
                                      )
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                        ]
                      ),
                      _vm.baseInfo.taskProc[2].ifDone === false
                        ? [
                            _c("div", { staticClass: "claim-btn off-btn" }, [
                              _vm._v(_vm._s(_vm.$t("lang.commonM.k073"))),
                            ]),
                          ]
                        : _vm._e(),
                      _vm.baseInfo.taskProc[2].ifDone === true
                        ? [
                            _vm.baseInfo.taskProc[2].ifClaimed === false
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "claim-btn",
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleClaim(
                                          _vm.baseInfo.taskProc[2],
                                          2
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("lang.commonM.k073")))]
                                )
                              : _c(
                                  "div",
                                  { staticClass: "claim-btn off-btn" },
                                  [_vm._v(_vm._s(_vm.$t("lang.commonM.k074")))]
                                ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  )
                : _vm._e(),
              _c("div", { staticClass: "still-block" }),
              _vm.baseInfo && _vm.baseInfo.ifValid
                ? _c("div", { staticClass: "top-up-block" }, [
                    _c(
                      "div",
                      {
                        staticClass: "top-up-btn",
                        on: { click: _vm.handleTopUp },
                      },
                      [
                        _c("img", {
                          attrs: { src: require("./images/star.png") },
                        }),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("lang.commonM.k146"))),
                        ]),
                        _c("img", {
                          attrs: { src: require("./images/star.png") },
                        }),
                      ]
                    ),
                    _c("div", {
                      style: { height: `${_vm.bottomBarHeight}px` },
                    }),
                  ])
                : _vm._e(),
            ]
          ),
        ]
      ),
      _vm.showSuccess
        ? _c("div", { staticClass: "act-mask" }, [
            _vm.successIndex === 0
              ? _c("div", { staticClass: "con-block" }, [
                  _c("div", { staticClass: "gifts-blank" }, [
                    _vm._v(_vm._s(_vm.$t("lang.commonM.k147"))),
                  ]),
                  _vm.baseInfo &&
                  _vm.baseInfo.taskProc &&
                  _vm.baseInfo.taskProc[0].rewards
                    ? _c("div", { staticClass: "gifts" }, [
                        _c("div", [
                          _c("img", {
                            attrs: { src: _vm.getMatchImg("coins"), alt: "" },
                          }),
                          _c("div", { staticClass: "rewards-count" }, [
                            _vm._v(
                              "x" +
                                _vm._s(
                                  _vm.baseInfo.taskProc[0].rewards[0].number
                                )
                            ),
                          ]),
                        ]),
                        _c("div", [
                          _c("img", {
                            attrs: { src: _vm.getMatchImg("coupon"), alt: "" },
                          }),
                          _c("div", { staticClass: "rewards-count" }, [
                            _vm._v(
                              "x" +
                                _vm._s(
                                  _vm.baseInfo.taskProc[0].rewards[1].number
                                )
                            ),
                          ]),
                        ]),
                      ])
                    : _vm._e(),
                  _c("div", { staticClass: "gifts" }, [
                    _c("div", [
                      _c("img", {
                        attrs: { src: _vm.getMatchImg("video-pass"), alt: "" },
                      }),
                      _c("div", { staticClass: "rewards-count" }, [
                        _vm._v(
                          "x" +
                            _vm._s(_vm.baseInfo.taskProc[0].rewards[2].number)
                        ),
                      ]),
                    ]),
                    _c("div", [
                      _c("img", {
                        attrs: {
                          src: _vm.getMatchImg("super-chat-pass"),
                          alt: "",
                        },
                      }),
                      _c("div", { staticClass: "rewards-count" }, [
                        _vm._v(
                          "x" +
                            _vm._s(_vm.baseInfo.taskProc[0].rewards[3].number)
                        ),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "rules-confirm" }, [
                    _c(
                      "div",
                      {
                        on: {
                          click: function ($event) {
                            _vm.showSuccess = false
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("lang.ok")))]
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm.successIndex === 1
              ? _c("div", { staticClass: "con-block" }, [
                  _c("div", { staticClass: "gifts-blank" }, [
                    _vm._v(_vm._s(_vm.$t("lang.commonM.k147"))),
                  ]),
                  _vm.baseInfo &&
                  _vm.baseInfo.taskProc &&
                  _vm.baseInfo.taskProc[1].rewards
                    ? _c("div", { staticClass: "gifts" }, [
                        _c("div", [
                          _c("img", {
                            attrs: { src: _vm.getMatchImg("coins"), alt: "" },
                          }),
                          _c("div", { staticClass: "rewards-count" }, [
                            _vm._v(
                              "x" +
                                _vm._s(
                                  _vm.baseInfo.taskProc[1].rewards[0].number
                                )
                            ),
                          ]),
                        ]),
                        _c("div", [
                          _c("img", {
                            attrs: {
                              src: _vm.getMatchImg("video-pass"),
                              alt: "",
                            },
                          }),
                          _c("div", { staticClass: "rewards-count" }, [
                            _vm._v(
                              "x" +
                                _vm._s(
                                  _vm.baseInfo.taskProc[1].rewards[1].number
                                )
                            ),
                          ]),
                        ]),
                        _c("div", [
                          _c("img", {
                            attrs: {
                              src: _vm.getMatchImg("super-chat-pass"),
                              alt: "",
                            },
                          }),
                          _c("div", { staticClass: "rewards-count" }, [
                            _vm._v(
                              "x" +
                                _vm._s(
                                  _vm.baseInfo.taskProc[1].rewards[2].number
                                )
                            ),
                          ]),
                        ]),
                      ])
                    : _vm._e(),
                  _c("div", { staticClass: "rules-confirm" }, [
                    _c(
                      "div",
                      {
                        on: {
                          click: function ($event) {
                            _vm.showSuccess = false
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("lang.ok")))]
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm.successIndex === 2
              ? _c("div", { staticClass: "con-block" }, [
                  _c("div", { staticClass: "gifts-blank" }, [
                    _vm._v(_vm._s(_vm.$t("lang.commonM.k147"))),
                  ]),
                  _vm.baseInfo &&
                  _vm.baseInfo.taskProc &&
                  _vm.baseInfo.taskProc[2].rewards
                    ? _c("div", { staticClass: "gifts" }, [
                        _c("div", [
                          _c("img", {
                            attrs: { src: _vm.getMatchImg("coins"), alt: "" },
                          }),
                          _c("div", { staticClass: "rewards-count" }, [
                            _vm._v(
                              "x" +
                                _vm._s(
                                  _vm.baseInfo.taskProc[2].rewards[0].number
                                )
                            ),
                          ]),
                        ]),
                        _c("div", [
                          _c("img", {
                            attrs: {
                              src: _vm.getMatchImg("video-pass"),
                              alt: "",
                            },
                          }),
                          _c("div", { staticClass: "rewards-count" }, [
                            _vm._v(
                              "x" +
                                _vm._s(
                                  _vm.baseInfo.taskProc[2].rewards[1].number
                                )
                            ),
                          ]),
                        ]),
                        _c("div", [
                          _c("img", {
                            attrs: {
                              src: _vm.getMatchImg("super-chat-pass"),
                              alt: "",
                            },
                          }),
                          _c("div", { staticClass: "rewards-count" }, [
                            _vm._v(
                              "x" +
                                _vm._s(
                                  _vm.baseInfo.taskProc[2].rewards[2].number
                                )
                            ),
                          ]),
                        ]),
                      ])
                    : _vm._e(),
                  _c("div", { staticClass: "rules-confirm" }, [
                    _c(
                      "div",
                      {
                        on: {
                          click: function ($event) {
                            _vm.showSuccess = false
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("lang.ok")))]
                    ),
                  ]),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _vm.showRules
        ? _c("div", { staticClass: "act-mask" }, [
            _c("div", { staticClass: "act-rules" }, [
              _c("div", { staticClass: "reward-head" }, [
                _c("img", { attrs: { src: require("./images/star.png") } }),
                _c("span", [_vm._v(_vm._s(_vm.$t("lang.commonM.k111")))]),
                _c("img", { attrs: { src: require("./images/star.png") } }),
              ]),
              _c("div", { staticClass: "act-rules-item" }, [
                _c("span", [_vm._v("1.")]),
                _c("p", [_vm._v(_vm._s(_vm.$t("lang.commonM.k148")))]),
              ]),
              _c("div", { staticClass: "act-rules-item" }, [
                _c("span", [_vm._v("2.")]),
                _c("p", [_vm._v(_vm._s(_vm.$t("lang.commonM.k149")))]),
              ]),
              _c("div", { staticClass: "act-rules-item" }, [
                _c("span", [_vm._v("3.")]),
                _c("p", [_vm._v(_vm._s(_vm.$t("lang.commonM.k150")))]),
              ]),
              _c("div", { staticClass: "rules-confirm" }, [
                _c(
                  "div",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.toggleShowRules(false)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("lang.commonM.k112")))]
                ),
              ]),
            ]),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }